import { Action } from '@ngrx/store';
import { TLLBoardInfoActionType, TWithoutPlanVersion } from './ll-board.models';
import {
  TREQUEST_ADD_EDIT_LINE_WORKING_HOURS,
  TREQUEST_LlBoardListing,
  TRESPONSE_LLBoardListing,
  TRESPONSE_LL_SHIFT,
  TRESPONSE_LL_TASK_MANAGER,
  TRESPONSE_LL_LEARNING_CURVE_DETAILS,
  TREQUEST_ADD_UPDATE_LL_LEARNING_CURVE,
  TREQUEST_ADD_UPDATE_LL_LC_BY_FACTORY_OTL,
  TRESPONSE_LL_LEARNING_CURVE_BY_FACTORY_OTL,
  TREQUEST_LINE_LEVEL_STRIP_LIST,
  TRESPONSE_LINE_LEVEL_STRIP_LIST,
  TREQUEST_UNLOAD_STRIP_MOVE_PARTIALLY,
  TREQUEST_ADD_EDIT_NOTE,
  TRESPONSE_LINE_STRIP_PLANNED_NUMBERS,
  TREQUEST_ADD_EDIT_LINE_WORKFORCE_COUNT,
  TREQUEST_RESET_LINE_WORKFORCE_COUNT,
  TREQUEST_RESET_LINE_SHIFT_COUNT,
  TRESPONSE_LL_LOAD_ORDER_THRESHOLD,
  TREQUEST_LL_ADD_LEARNING_CURVE_DAY,
  TLlBoardVersion,
} from '@monorepo/types';
import { TLLRectDropElement } from '@monorepo/ui';

export class GetLLBoardList implements Action {
  readonly type = TLLBoardInfoActionType.GetLLBoardList;
  constructor(public payload: TWithoutPlanVersion<TREQUEST_LlBoardListing>) {}
}

export class GetLLBoardListSuccess implements Action {
  readonly type = TLLBoardInfoActionType.GetLLBoardListSuccess;
  constructor(public payload: TRESPONSE_LLBoardListing) {}
}

export class GetLineShiftInfo implements Action {
  readonly type = TLLBoardInfoActionType.GetLineShiftInfo;
  constructor(public subjectId: string, public factoryId: string, public shiftId?: string) {}
}

export class GetLineShiftInfoSuccess implements Action {
  readonly type = TLLBoardInfoActionType.GetLineShiftInfoSuccess;
  constructor(public lineShiftRes: TRESPONSE_LL_SHIFT) {}
}

export class GetLineShiftInfoFailure implements Action {
  readonly type = TLLBoardInfoActionType.GetLineShiftInfoFailure;
}

export class AddEditLineWorkingHours implements Action {
  readonly type = TLLBoardInfoActionType.AddEditLineWorkingHours;
  constructor(
    public factoryId: string,
    public payload: TWithoutPlanVersion<TREQUEST_ADD_EDIT_LINE_WORKING_HOURS>,
    public subjectId: string,
  ) {}
}

export class AddEditLineWorkingHoursSuccess implements Action {
  readonly type = TLLBoardInfoActionType.AddEditLineWorkingHoursSuccess;
}

export class AddEditLineWorkingHoursFailure implements Action {
  readonly type = TLLBoardInfoActionType.AddEditLineWorkingHoursFailure;
}

export class ResetLineWorkingHours implements Action {
  readonly type = TLLBoardInfoActionType.ResetLineWorkingHours;
  constructor(
    public factoryId: string,
    public payload: TWithoutPlanVersion<TREQUEST_RESET_LINE_SHIFT_COUNT>,
    public subjectId: string,
  ) {}
}

export class ResetLineWorkingHoursSuccess implements Action {
  readonly type = TLLBoardInfoActionType.ResetLineWorkingHoursSuccess;
}

export class ResetLineWorkingHoursFailure implements Action {
  readonly type = TLLBoardInfoActionType.ResetLineWorkingHoursFailure;
}

export class SetLoadStripOnMouse implements Action {
  readonly type = TLLBoardInfoActionType.SetLoadStripOnMouse;
  constructor(public loadStrip: TLLRectDropElement[] | null) {}
}
export class GetLLBoardTaskManager implements Action {
  readonly type = TLLBoardInfoActionType.GetLLBoardTaskManager;
}

export class GetLLBoardTaskManagerSuccess implements Action {
  readonly type = TLLBoardInfoActionType.GetLLBoardTaskManagerSuccess;
  constructor(public res: TRESPONSE_LL_TASK_MANAGER) {}
}

export class GetLLBoardTaskManagerFailure implements Action {
  readonly type = TLLBoardInfoActionType.GetLLBoardTaskManagerFailure;
}

export class GetLearningCurveStripeInfo implements Action {
  readonly type = TLLBoardInfoActionType.GetLearningCurveStripeInfo;
  constructor(public stripId: string, public shiftId?: string) {}
}

export class GetLearningCurveStripeInfoSuccess implements Action {
  readonly type = TLLBoardInfoActionType.GetLearningCurveStripeInfoSuccess;
  constructor(public learningCurveStripRes: TRESPONSE_LL_LEARNING_CURVE_DETAILS) {}
}

export class GetLearningCurveStripeInfoFailure implements Action {
  readonly type = TLLBoardInfoActionType.GetLearningCurveStripeInfoFailure;
}

export class UpdateLearningCurveDayCount implements Action {
  readonly type = TLLBoardInfoActionType.UpdateLearningCurveDayCount;
  constructor(public stripId: string, public payload: TWithoutPlanVersion<TREQUEST_LL_ADD_LEARNING_CURVE_DAY>) {}
}

export class UpdateLearningCurveDayCountSuccess implements Action {
  readonly type = TLLBoardInfoActionType.UpdateLearningCurveDayCountSuccess;
}

export class UpdateLearningCurveDayCountFailure implements Action {
  readonly type = TLLBoardInfoActionType.UpdateLearningCurveDayCountFailure;
}

export class AddEditLearningCurveStrip implements Action {
  readonly type = TLLBoardInfoActionType.AddEditLearningCurveStrip;
  constructor(public stripId: string, public payload: TWithoutPlanVersion<TREQUEST_ADD_UPDATE_LL_LEARNING_CURVE>) {}
}

export class AddEditLearningCurveStripSuccess implements Action {
  readonly type = TLLBoardInfoActionType.AddEditLearningCurveStripSuccess;
}

export class AddEditLearningCurveStripFailure implements Action {
  readonly type = TLLBoardInfoActionType.AddEditLearningCurveStripFailure;
}

export class DeleteLearningCurveStrip implements Action {
  readonly type = TLLBoardInfoActionType.DeleteLearningCurveStrip;
  constructor(public stripId: string, public shiftId?: string) {}
}

export class DeleteLearningCurveStripSuccess implements Action {
  readonly type = TLLBoardInfoActionType.DeleteLearningCurveStripSuccess;
}

export class DeleteLearningCurveStripFailure implements Action {
  readonly type = TLLBoardInfoActionType.DeleteLearningCurveStripFailure;
}

export class GetLearningCurveByFactoryOtl implements Action {
  readonly type = TLLBoardInfoActionType.GetLearningCurveByFactoryOtl;
  constructor(public factoryId: string, public otlId: string, public shiftId?: string) {}
}

export class GetLearningCurveByFactoryOtlSuccess implements Action {
  readonly type = TLLBoardInfoActionType.GetLearningCurveByFactoryOtlSuccess;
  constructor(public learningCurveFactoryOtlRes: TRESPONSE_LL_LEARNING_CURVE_BY_FACTORY_OTL) {}
}

export class GetLearningCurveByFactoryOtlFailure implements Action {
  readonly type = TLLBoardInfoActionType.GetLearningCurveByFactoryOtlFailure;
}

export class AddEditLearningCurveByFactoryOtl implements Action {
  readonly type = TLLBoardInfoActionType.AddEditLearningCurveByFactoryOtl;
  constructor(public payload: TREQUEST_ADD_UPDATE_LL_LC_BY_FACTORY_OTL) {}
}

export class AddEditLearningCurveByFactoryOtlSuccess implements Action {
  readonly type = TLLBoardInfoActionType.AddEditLearningCurveByFactoryOtlSuccess;
}

export class AddEditLearningCurveByFactoryOtlFailure implements Action {
  readonly type = TLLBoardInfoActionType.AddEditLearningCurveByFactoryOtlFailure;
}

export class GetLineStripListing implements Action {
  readonly type = TLLBoardInfoActionType.GetLineStripListing;
  constructor(public lineSubject: string, public payload: TWithoutPlanVersion<TREQUEST_LINE_LEVEL_STRIP_LIST>) {}
}

export class GetLineStripListingSuccess implements Action {
  readonly type = TLLBoardInfoActionType.GetLineStripListingSuccess;
  constructor(public lineStripListingRes: TRESPONSE_LINE_LEVEL_STRIP_LIST) {}
}

export class GetLineStripListingFailure implements Action {
  readonly type = TLLBoardInfoActionType.GetLineStripListingFailure;
}

export class LineStripPlannedNumbers implements Action {
  readonly type = TLLBoardInfoActionType.LineStripPlannedNumbers;
  constructor(public stripId: string, public factoryId: string, public shiftId?: string) {}
}

export class LineStripPlannedNumbersSuccess implements Action {
  readonly type = TLLBoardInfoActionType.LineStripPlannedNumbersSuccess;
  constructor(public stripPlannedNumbers: TRESPONSE_LINE_STRIP_PLANNED_NUMBERS) {}
}

export class LineStripPlannedNumbersFailure implements Action {
  readonly type = TLLBoardInfoActionType.LineStripPlannedNumbersFailure;
}

export class UnloadStripMovePartially implements Action {
  readonly type = TLLBoardInfoActionType.UnloadStripMovePartially;
  constructor(public payload: TREQUEST_UNLOAD_STRIP_MOVE_PARTIALLY) {}
}

export class UnloadStripMovePartiallySuccess implements Action {
  readonly type = TLLBoardInfoActionType.UnloadStripMovePartiallySuccess;
}

export class UnloadStripMovePartiallyFailure implements Action {
  readonly type = TLLBoardInfoActionType.UnloadStripMovePartiallyFailure;
}

export class AddEditNoteOnStrip implements Action {
  readonly type = TLLBoardInfoActionType.AddEditNoteOnStrip;
  constructor(public payload: TWithoutPlanVersion<TREQUEST_ADD_EDIT_NOTE>) {}
}

export class AddEditNoteOnStripSuccess implements Action {
  readonly type = TLLBoardInfoActionType.AddEditNoteOnStripSuccess;
}

export class AddEditNoteOnStripFailure implements Action {
  readonly type = TLLBoardInfoActionType.AddEditNoteOnStripFailure;
}

export class AddEditLineWorkForceCount implements Action {
  readonly type = TLLBoardInfoActionType.AddEditLineWorkForceCount;
  constructor(public payload: TWithoutPlanVersion<TREQUEST_ADD_EDIT_LINE_WORKFORCE_COUNT>, public factoryId: string) {}
}

export class AddEditLineWorkForceCountSuccess implements Action {
  readonly type = TLLBoardInfoActionType.AddEditLineWorkForceCountSuccess;
}

export class AddEditLineWorkForceCountFailure implements Action {
  readonly type = TLLBoardInfoActionType.AddEditLineWorkForceCountFailure;
}

export class ResetLineWorkForceCount implements Action {
  readonly type = TLLBoardInfoActionType.ResetLineWorkForceCount;
  constructor(public payload: TWithoutPlanVersion<TREQUEST_RESET_LINE_WORKFORCE_COUNT>, public factoryId: string) {}
}

export class ResetLineWorkForceCountSuccess implements Action {
  readonly type = TLLBoardInfoActionType.ResetLineWorkForceCountSuccess;
}

export class ResetLineWorkForceCountFailure implements Action {
  readonly type = TLLBoardInfoActionType.ResetLineWorkForceCountFailure;
}

export class SetLLPCDPEDThreshold implements Action {
  readonly type = TLLBoardInfoActionType.SetLLPCDPEDThreshold;
  constructor(public addPCDPEDThresholds: TRESPONSE_LL_LOAD_ORDER_THRESHOLD | null) {}
}

export class LoadPlanVersions implements Action {
  readonly type = TLLBoardInfoActionType.LoadPlanVersions;
  /** `keepVersionId` stays selected if it still exists; otherwise the LIVE version is selected. */
  constructor(public keepVersionId?: string | null) {}
}

export class LoadPlanVersionsSuccess implements Action {
  readonly type = TLLBoardInfoActionType.LoadPlanVersionsSuccess;
  constructor(public versions: TLlBoardVersion[], public keepVersionId?: string | null) {}
}

export class LoadPlanVersionsFailure implements Action {
  readonly type = TLLBoardInfoActionType.LoadPlanVersionsFailure;
}

export class SetPlanVersions implements Action {
  readonly type = TLLBoardInfoActionType.SetPlanVersions;
  constructor(public versions: TLlBoardVersion[]) {}
}

export class SetSelectedPlanVersion implements Action {
  readonly type = TLLBoardInfoActionType.SetSelectedPlanVersion;
  constructor(public versionId: string) {}
}

export class SetIsPromotingPlanVersion implements Action {
  readonly type = TLLBoardInfoActionType.SetIsPromotingPlanVersion;
  constructor(public isPromoting: boolean) {}
}

export class SetIsCreatingPlanVersion implements Action {
  readonly type = TLLBoardInfoActionType.SetIsCreatingPlanVersion;
  constructor(public isCreating: boolean) {}
}

export type TLLBoardActions =
  | GetLLBoardList
  | GetLLBoardListSuccess
  | GetLineShiftInfo
  | GetLineShiftInfoSuccess
  | GetLineShiftInfoFailure
  | AddEditLineWorkingHours
  | AddEditLineWorkingHoursSuccess
  | AddEditLineWorkingHoursFailure
  | ResetLineWorkingHours
  | ResetLineWorkingHoursSuccess
  | ResetLineWorkingHoursFailure
  | SetLoadStripOnMouse
  | GetLLBoardTaskManager
  | GetLLBoardTaskManagerSuccess
  | GetLLBoardTaskManagerFailure
  | GetLearningCurveStripeInfo
  | GetLearningCurveStripeInfoSuccess
  | GetLearningCurveStripeInfoFailure
  | UpdateLearningCurveDayCount
  | UpdateLearningCurveDayCountSuccess
  | UpdateLearningCurveDayCountFailure
  | AddEditLearningCurveStrip
  | AddEditLearningCurveStripSuccess
  | AddEditLearningCurveStripFailure
  | DeleteLearningCurveStrip
  | DeleteLearningCurveStripSuccess
  | DeleteLearningCurveStripFailure
  | GetLearningCurveByFactoryOtl
  | GetLearningCurveByFactoryOtlSuccess
  | GetLearningCurveByFactoryOtlFailure
  | AddEditLearningCurveByFactoryOtl
  | AddEditLearningCurveByFactoryOtlSuccess
  | AddEditLearningCurveByFactoryOtlFailure
  | GetLineStripListing
  | GetLineStripListingSuccess
  | GetLineStripListingFailure
  | LineStripPlannedNumbers
  | LineStripPlannedNumbersSuccess
  | LineStripPlannedNumbersFailure
  | UnloadStripMovePartially
  | UnloadStripMovePartiallySuccess
  | UnloadStripMovePartiallyFailure
  | AddEditNoteOnStrip
  | AddEditNoteOnStripSuccess
  | AddEditNoteOnStripFailure
  | AddEditLineWorkForceCount
  | AddEditLineWorkForceCountSuccess
  | AddEditLineWorkForceCountFailure
  | ResetLineWorkForceCount
  | ResetLineWorkForceCountSuccess
  | ResetLineWorkForceCountFailure
  | SetLLPCDPEDThreshold
  | LoadPlanVersions
  | LoadPlanVersionsSuccess
  | LoadPlanVersionsFailure
  | SetPlanVersions
  | SetSelectedPlanVersion
  | SetIsCreatingPlanVersion
  | SetIsPromotingPlanVersion;
